import { Component } from "react";

import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import RefreshButton from "../../../shared/ui/Refresh.Button";
import ApiButton from "../../../shared/ui/Api.Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { invoiceStages } from "admin/shared/dictionary/enums";
import JSONTree from "react-json-tree";

import { download } from "admin/shared/ui/download.js";
import { invoicesConnector } from "../../../services/invoices/connector";
import { compose } from "redux";
import { userInvoicesConnector } from "../../../services/invoices/user.invoices/connector";

class InvoiceDetails extends Component {
  render() {
    return <JSONTree hideRoot={true} data={this.props.item} />;
  }
}

export const CurrenciesDropdown = ({ currency, setCurrency }) => {
  const currencyMenuItems = [
    <MenuItem value={1} key={"SEK"}>
      SEK
    </MenuItem>,
    <MenuItem value={2} key={"EUR"}>
      EUR
    </MenuItem>,
  ];

  return (
    <TextField
      size="small"
      variant="outlined"
      select
      label="Currency"
      value={currency}
      onChange={setCurrency}
    >
      {currencyMenuItems}
    </TextField>
  );
};

export const YearsDropdown = ({ year, setYear }) => {
  const currentYear = new Date().getFullYear();
  const beginYear = 2010;
  const menuItems = [];

  for (let i = beginYear; i <= currentYear; i++) {
    menuItems.push(
      <MenuItem value={i} key={i + "_year"}>
        {i}
      </MenuItem>,
    );
  }

  return (
    <TextField
      size="small"
      variant="outlined"
      select
      label="Year"
      value={year}
      onChange={setYear}
    >
      {menuItems}
    </TextField>
  );
};

export const MonthsDropdown = ({ month, setMonth }) => {
  const menuItems = [
    <MenuItem value={1} key={"January"}>
      January
    </MenuItem>,
    <MenuItem value={2} key={"February"}>
      February
    </MenuItem>,
    <MenuItem value={3} key={"March"}>
      March
    </MenuItem>,
    <MenuItem value={4} key={"April"}>
      April
    </MenuItem>,
    <MenuItem value={5} key={"May"}>
      May
    </MenuItem>,
    <MenuItem value={6} key={"June"}>
      June
    </MenuItem>,
    <MenuItem value={7} key={"July"}>
      July
    </MenuItem>,
    <MenuItem value={8} key={"August"}>
      August
    </MenuItem>,
    <MenuItem value={9} key={"September"}>
      September
    </MenuItem>,
    <MenuItem value={10} key={"October"}>
      October
    </MenuItem>,
    <MenuItem value={11} key={"November"}>
      November
    </MenuItem>,
    <MenuItem value={12} key={"December"}>
      December
    </MenuItem>,
  ];

  return (
    <TextField
      size="small"
      variant="outlined"
      select
      label="Month"
      value={month}
      onChange={setMonth}
    >
      {menuItems}
    </TextField>
  );
};

class InvoicesComponent extends Component {
  constructor(props) {
    super(props);

    //ToDo InvoiceRows and Repayments columns
    let columns = [
      {
        key: "AccountId",
        label: "Get ssn",
        filter: false,
        visible: true,
        type: CELL_TYPES.ssn,
      },
      {
        key: "AccountId",
        label: "Account Id",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"accountId"} />;
        },
      },
      {
        key: "_amount.Amount",
        label: "Amount",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Amount.Amount",
        label: "Amount paid",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Stage",
        label: "Stage",
        visible: true,
        enumDict: invoiceStages,
        type: CELL_TYPES.enum,
      },
      {
        key: "AssetId",
        label: "Loan Id",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "RefCode",
        label: "Ref code",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "DueDate",
        label: "Due Date",
        visible: true,
        type: CELL_TYPES.date,
      },
    ];

    let stColumns = [
      {
        key: "AccountId",
        label: "Get ssn",
        filter: false,
        visible: true,
        type: CELL_TYPES.ssn,
      },
      {
        key: "AccountId",
        label: "Account Id",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"accountId"} />;
        },
      },
      {
        key: "Amount.Amount",
        label: "Amount",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Capital.Amount",
        label: "Capital",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Total.Amount",
        label: "Total",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "DiscountDays",
        label: "Discount days",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "CreditId",
        label: "Loan Id",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "RefCode",
        label: "Ref code",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "DueDate",
        label: "Due Date",
        visible: true,
        type: CELL_TYPES.date,
      },
    ];

    this.state = {
      columns,
      stColumns,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      loadingInvoicesReport: false,
      invoiceStagesFilter: {
        ToBePaid: true,
        PartiallyPaid: true,
        Late: true,
        Credited: true,
        UpComing: false,
        FullyPaid: false,
      },
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.accountId) {
      this.fetchAccountInvoices(this.props.accountId);
    } else if (this.props.invoices.data && !this.props.invoices.data.length) {
      this.fetchInvoices();
    }
    this.props.changeInvoiceListPage(1);
  }

  changeStagesFilter(type) {
    let newTypeValue = !this.state.invoiceStagesFilter[type];
    this.setState({
      invoiceStagesFilter: Object.assign({}, this.state.invoiceStagesFilter, {
        [type]: newTypeValue,
      }),
    });
  }

  setMonth = (event) => {
    this.setState({
      ...this.state,
      month: event.target.value,
    });
  };

  setYear = (event) => {
    this.setState({
      ...this.state,
      year: event.target.value,
    });
  };

  downloadFile = () => {
    let that = this;
    let year = this.state.year;
    let month = this.state.month;
    let url =
      "/api/admin/invoices/xlsx?year=" +
      this.state.year +
      "&month=" +
      this.state.month;
    let token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];

    that.setState({
      ...that.state,
      loadingInvoicesReport: true,
    });

    return fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((resp) => {
        that.setState({
          ...that.state,
          loadingInvoicesReport: false,
        });
        if (resp.status >= 400 && resp.status < 600) {
          alert("Couldn't download file.");
          return "Error";
        } else {
          return resp.blob();
        }
      })
      .then((blob) => {
        if (blob != "Error") {
          download(
            blob,
            "ReportInvoices" + month + "" + year + ".xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          );
        }
      });
  };

  fetchAccountInvoices = () => {
    //this.props.getInvoicesByAccount(accountId);
  };

  fetchInvoices = () => {
    //this.props.getInvoices();
  };

  render() {
    let refreshFunction;
    let invoices;

    refreshFunction = this.props.accountId
      ? this.fetchAccountInvoices.bind(this, this.props.accountId)
      : this.fetchInvoices;

    if (this.props.invoices && this.props.invoices.data) {
      invoices = this.props.invoices.data.filter((invoice) => {
        return this.state.invoiceStagesFilter[invoice.Stage];
      });
    }

    return (
      <div className="content-padding">
        <div className="invoices-layout body-height content-padding">
          <RefreshButton onRefreshClick={refreshFunction} />
          {this.props.accountId ? (
            <h3>Account invoices:</h3>
          ) : (
            <h3>Unpaid invoices:</h3>
          )}
          {!this.props.invoices.fetched ? (
            <div> Loading... </div>
          ) : (
            <div>
              <div>
                <div style={{ minWidth: "25%", display: "inline-block" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.invoiceStagesFilter.ToBePaid}
                        onCheck={this.changeStagesFilter.bind(this, "ToBePaid")}
                      />
                    }
                    label="ToBePaid"
                  />
                </div>
                <div style={{ minWidth: "25%", display: "inline-block" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.invoiceStagesFilter.PartiallyPaid}
                        onCheck={this.changeStagesFilter.bind(
                          this,
                          "PartiallyPaid",
                        )}
                      />
                    }
                    label="PartiallyPaid"
                  />
                </div>
                <div style={{ minWidth: "25%", display: "inline-block" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.invoiceStagesFilter.Late}
                        onCheck={this.changeStagesFilter.bind(this, "Late")}
                      />
                    }
                    label="Late"
                  />
                </div>
                <div style={{ minWidth: "25%", display: "inline-block" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.invoiceStagesFilter.Credited}
                        onCheck={this.changeStagesFilter.bind(this, "Credited")}
                      />
                    }
                    label="Credited"
                  />
                </div>
              </div>
              <div>
                <div style={{ minWidth: "25%", display: "inline-block" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.invoiceStagesFilter.FullyPaid}
                        onCheck={this.changeStagesFilter.bind(
                          this,
                          "FullyPaid",
                        )}
                      />
                    }
                    label="FullyPaid"
                  />
                </div>
                <div style={{ minWidth: "25%", display: "inline-block" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.invoiceStagesFilter.UpComing}
                        onCheck={this.changeStagesFilter.bind(this, "UpComing")}
                      />
                    }
                    label="UpComing"
                  />
                </div>
              </div>
              <TableNew
                columns={this.state.columns}
                items={invoices}
                tableKey="invoicesTable"
                showDetails={true}
                detailsRenderer={(item) => {
                  return <InvoiceDetails item={item} />;
                }}
              />
            </div>
          )}
          {!this.props.accountId ? (
            <div>
              <h3>Get invoices:</h3>
              <YearsDropdown setYear={this.setYear} year={this.state.year} />
              <MonthsDropdown
                setMonth={this.setMonth}
                month={this.state.month}
              />
              <ApiButton
                sending={this.state.loadingInvoicesReport}
                onButtonClick={this.downloadFile}
                buttonLabel={"Download"}
              />
            </div>
          ) : undefined}
        </div>
      </div>
    );
  }
}
export const Invoices = compose(invoicesConnector)(InvoicesComponent);
export const UserInvoices = compose(userInvoicesConnector)(InvoicesComponent);
